import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { constants } from '../constants/constants';

const PROJECT_LIST = /^\/client\/project\/(started|published|archived)(\/[^/?#]+\/details)?(?:[?#].*)?$/;

/**
 * Confines a CLIENT (client-portal user, MP-5750) to the project list and
 * project details routes under /client, plus the Worked Together screen
 * (MP-5754). Every other /client URL, including the `**` fallback to
 * overview, project create/edit, unpublished, the rest of people, settings
 * and so on, redirects to the Started project list. The one settings route
 * allowed is change password, which the sidenav opens.
 *
 * Mounted as `canActivateChild` on the dashboard route, so it runs for every
 * child activation with the full target URL. FM, PM and PO are not affected:
 * their access is still decided by ClientAuthRoleGuard alone.
 *
 * Distinct from `clientPortalGuard` (client-portal.guard.ts), which gates the
 * firm-side Client Groups screen on the tenant capability.
 */
export function isClientPortalUrl(url: string): boolean {
  const path = (url || '').split(/[?#]/)[0];
  return PROJECT_LIST.test(url || '') || path === constants.clientPortal.changePasswordUrl
    || path === constants.clientPortal.workedTogetherUrl;
}

export const clientPortalRoleGuard: CanActivateChildFn = (childRoute, state) => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  if (storageService.getRole() !== constants.userRoles.client) {
    return true;
  }
  return isClientPortalUrl(state.url) ? true : router.createUrlTree([constants.clientPortal.homeUrl]);
};
